import React, { useState, useEffect } from "react";
import "./Inner_Description.css";
import { BlogById } from "../../../../utils/apis/blog/Blog";

const Inner_Description = ({ blogId }) => {
  const benefits = [
    {
      id: 1,
      title: "Rising Electricity Costs Make Solar a Wise Choice",
      text: `Electricity tariffs in India increase almost every year. Air conditioners, geysers, EV chargers, & work-from-home setups significantly raise monthly power bills. Installing rooftop solar panels allows you to generate your own electricity & drastically reduce your dependency on the grid. In many homes, solar can cut electricity bills by up to 90%.`,
    },
    {
      id: 2,
      title: "High Return on Investment (ROI)",
      text: `Solar systems typically recover their cost within 4–6 years, depending on usage & system size. After that, the electricity you generate is virtually free for the next 20–25 years. Compared to traditional investments, solar offers stable, risk-free returns with long-term savings.`,
    },
    {
      id: 3,
      title: "Government Subsidies & Net Metering Benefits",
      text: `The Indian government actively promotes rooftop solar through subsidies & incentives. Homeowners can also benefit from net metering, where excess electricity generated is exported to the grid, reducing future bills or even earning credits. These policies make solar more affordable & financially attractive than ever.`,
    },
    {
      id: 4,
      title: "Reliable Power with Minimal Maintenance",
      text: `Solar panels are highly durable and designed to withstand Indian weather conditions—from intense heat to heavy rains. With minimal maintenance such as occasional cleaning, solar systems continue to perform efficiently for decades, offering hassle-free energy independence.`,
    },
    {
      id: 5,
      title: "Environment-Friendly & Future-Ready",
      text: `Solar energy is clean, renewable, and significantly reduces carbon emissions. By switching to solar, homeowners actively contribute to a greener India while preparing their homes for a future where sustainable energy will be the norm, not the exception.`,
    },
    {
      id: 6,
      title: "Increased Property Value",
      text: `Homes equipped with solar systems are more attractive to buyers and tenants. Lower electricity costs and energy independence increase property value, making solar a smart investment not just for savings—but also for long-term asset growth.`,
    },
    {
      id: 7,
      title: "Ideal for Indian Climate",
      text: `India receives abundant sunlight throughout the year, making solar energy extremely efficient and reliable. Rooftop solar systems are perfectly suited for independent houses, villas, & housing societies across urban and rural India.`,
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [indescription, setInDescription] = useState("");

  const getInDescription = async () => {
    const res = await BlogById(blogId);

    if (res?.success) {
      setInDescription(res?.data?.description || "");
    }
  };

  useEffect(() => {
    if (blogId) {
      getInDescription();
    }
  }, [blogId]);

  return (
    <section className="Inner_Description">
      <div className="Inner_Description_header_holder">
        <p className="Inner_Description_header">
          (All Event Orders Accepted) ( Wedding, Engagement Ceremony,
          Housewarming Ritual,Birthday party,Baby shower function,Naming
          ceremony)
        </p>
      </div>

      <div className="Inner_Description_benefits">
        {/* <div key={item.id} className="benefit_item pb-2"> */}
        <h5 className="benefit_title">
          {/* <span>{item.id}.</span> {item.title} */}
        </h5>
        <p className="benefit_text">{htmlToReactParser.parse(indescription)}</p>
        <hr />
      </div>

      {/* </div> */}
    </section>
  );
};

export default Inner_Description;
